import log from "loglevel";
import PriceFilter from "../filters/price";
import CartService from "../services/cart.service";
import { DisplayPricesWithTax } from "../services/store.service";

const cartTotalButton = document.getElementById("cart-total");

CartService.onChange(({total, totalWithoutTax}) => {
    if (cartTotalButton != null) {
        if (DisplayPricesWithTax === true) {
            cartTotalButton.innerText = PriceFilter(total);
        } else {
            cartTotalButton.innerText = PriceFilter(totalWithoutTax);
        }
    }
    log.info("Cart updated.", { total });
});